import { sanitize } from 'dompurify';

export const sanitizeText = (text: string) => {
  return sanitize(text, { ADD_ATTR: ['target'] });
};
